// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Vazirmatn:wght@400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 🔹 تنظیمات عمومی */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Vazirmatn", sans-serif;
}

body {
  background: #ffffff !important;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
}

/* 🔹 کانتینر اصلی */
.container {
  width: 1000px;
  height: 600px;
  display: flex;
  border-radius: 20px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
}

/* 🔹 بخش لاگین */
.login-section {
  width: 100%;
  padding: 40px;
}

/* 🔹 فیلدهای ورودی */
.input-box {
  width: 100%;
  background: #f0f2f5;
  border: 1px solid #ddd;
  outline: none;
  padding: 15px;
  margin: 10px 0;
  border-radius: 10px;
  color: #333;
  font-size: 14px;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.input-box:focus {
  border-color: #5b8def;
  box-shadow: 0 0 5px rgba(91, 141, 239, 0.4);
}

/* 🔹 رسپانسیو */

/* لپ‌تاپ متوسط */
@media (max-width: 1024px) {
  .container {
    width: 90%;
    height: auto;
    flex-direction: column;
  }

  .login-section {
    padding: 30px;
  }
}

/* تبلت */
@media (max-width: 768px) {
  .container {
    width: 100%;
    border-radius: 15px;
  }

  .login-section {
    padding: 25px;
  }

  .input-box {
    font-size: 13px;
    padding: 12px;
  }
}

/* موبایل */
@media (max-width: 480px) {
  body {
    align-items: flex-start;
    padding: 20px 0;
  }

  .container {
    width: 100%;
    height: auto;
    border-radius: 10px;
    box-shadow: none;
  }

  .login-section {
    padding: 20px;
  }

  .input-box {
    font-size: 12px;
    padding: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LoginForm/loginFrom.css"],"names":[],"mappings":"AAEA,qBAAqB;AACrB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA,gBAAgB;;AAEhB,iBAAiB;AACjB;EACE;IACE,UAAU;IACV,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,SAAS;AACT;EACE;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,aAAa;EACf;AACF;;AAEA,WAAW;AACX;EACE;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,aAAa;EACf;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Vazirmatn:wght@400;500;700&display=swap');\n\n/* 🔹 تنظیمات عمومی */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Vazirmatn\", sans-serif;\n}\n\nbody {\n  background: #ffffff !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n}\n\n/* 🔹 کانتینر اصلی */\n.container {\n  width: 1000px;\n  height: 600px;\n  display: flex;\n  border-radius: 20px;\n  overflow: hidden;\n  background: #ffffff;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);\n}\n\n/* 🔹 بخش لاگین */\n.login-section {\n  width: 100%;\n  padding: 40px;\n}\n\n/* 🔹 فیلدهای ورودی */\n.input-box {\n  width: 100%;\n  background: #f0f2f5;\n  border: 1px solid #ddd;\n  outline: none;\n  padding: 15px;\n  margin: 10px 0;\n  border-radius: 10px;\n  color: #333;\n  font-size: 14px;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.input-box:focus {\n  border-color: #5b8def;\n  box-shadow: 0 0 5px rgba(91, 141, 239, 0.4);\n}\n\n/* 🔹 رسپانسیو */\n\n/* لپ‌تاپ متوسط */\n@media (max-width: 1024px) {\n  .container {\n    width: 90%;\n    height: auto;\n    flex-direction: column;\n  }\n\n  .login-section {\n    padding: 30px;\n  }\n}\n\n/* تبلت */\n@media (max-width: 768px) {\n  .container {\n    width: 100%;\n    border-radius: 15px;\n  }\n\n  .login-section {\n    padding: 25px;\n  }\n\n  .input-box {\n    font-size: 13px;\n    padding: 12px;\n  }\n}\n\n/* موبایل */\n@media (max-width: 480px) {\n  body {\n    align-items: flex-start;\n    padding: 20px 0;\n  }\n\n  .container {\n    width: 100%;\n    height: auto;\n    border-radius: 10px;\n    box-shadow: none;\n  }\n\n  .login-section {\n    padding: 20px;\n  }\n\n  .input-box {\n    font-size: 12px;\n    padding: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
